import { render, staticRenderFns } from "./oldInfoList.vue?vue&type=template&id=771af12e&scoped=true&"
import script from "./oldInfoList.vue?vue&type=script&lang=js&"
export * from "./oldInfoList.vue?vue&type=script&lang=js&"
import style0 from "./oldInfoList.vue?vue&type=style&index=0&id=771af12e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771af12e",
  null
  
)

export default component.exports